import React from "react";

const LandingPage = () => {
    return (
        <div>
            <h1>Welcome to the sell zone. A place to sell and buy products.</h1>
        </div>
    )
}

export default LandingPage